require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-ri-46-b.json") })
        }
      }, "path---photos-professional-ri-46-b");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-ri-46-b!./.cache/json/photos-professional-ri-46-b.json
// module id = 888
// module chunks = 231608221292675